<!-- CONTAINER -->
<div
	class="bg-white pb-36px pt-24px px-24px rounded-tl-[24px] rounded-tr-[24px]"
>
	<!-- HEADER SECTION -->

	<!-- COUNTRIES -->
	<div
		class="max-w-[406px] flex justify-evenly items-center py-[8px] px-[10px] bg-off-white rounded-[50px] text-dark-grey mt-[18px] mb-[18px] text-font-16 cursor-pointer border-secondry-color-Gray border-[1px]"
	>
		<a
			routerLink="/layout/wallet"
			[queryParams]="{ country: country.id }"
			*ngFor="let country of activeCountries"
			class="text-center w-[55%] max-mobile:text-font-mobile-small"
			[ngClass]="{ activeClass: walletFilter.countryId == country.id }"
		>
			<!-- prettier-ignore -->
			<img class="inline-block w-[24px]" [src]="attachmentUrl + country.flagUrl" alt="" />
			{{
				this.translate.currentLang === 'ar'
					? country?.name?.ar
					: country?.name?.en
			}}
		</a>
	</div>
	<!-- tabs -->
	<div class="mb-[18px] overflow-x-auto">
		<app-tabs
			[taps]="walletStatus"
			[activeTap]="walletFilter.activeTab"
			(tapChanged)="tapChanged($event)"
		>
		</app-tabs>
	</div>

	<div class="p-24px shadow rounded-12px">
		<!-- total balance  -->

		<div
			class="p-24px bg-img rounded-12px mb-24px min-h-[170px] flex items-center"
		>
			<div>
				<p class="text-off-white text-font-14 mb-6px">
					{{ 'WALLET.SP_WALLET.TOTALCOUNT' | translate }}
				</p>
				<h1 class="text-off-white text-font-24 font-DIN-bold mb-[3px]">
					{{ adminWalletTotal?.totalAmount }}
					<span class="mx-6px">{{
						translate.currentLang == 'en'
							? adminWalletTotal?.currency?.name?.en
							: adminWalletTotal?.currency?.name?.ar
					}}</span>
				</h1>
				<p class="text-off-white text-font-16 mb-0">
					{{ 'WALLET.SP_WALLET.HOLD_AMOUNT' | translate }}:
					{{ adminWalletTotal?.totalHoldedAmount }}
					<span>{{
						translate.currentLang == 'en'
							? adminWalletTotal?.currency?.name?.en
							: adminWalletTotal?.currency?.name?.ar
					}}</span>
				</p>
			</div>
		</div>

		<!-- filter -->
		<app-search-filter
			(toggleFilter)="sidenav.toggle()"
			(keyWord)="
				walletFilter.searchText = $event;
				walletFilter.activeTab == 0
					? getSpWalletList(true)
					: getClientWalletList(true)
			"
			searchKey="WALLET.WALLET_LIST.SEARCH"
			[filterCount]="filterCount"
			(resetFilter)="filter.resetFilter()"
			[showFilter]="walletFilter.activeTab == 0"
		></app-search-filter>

		<!-- table -->
		<app-wallet-table
			(actionChanged)="
				walletFilter.activeTab == 0 ? getSpWalletList() : getClientWalletList()
			"
			[clientWallets]="clientWalletList"
			[spWallets]="spWallets"
			[walletFilter]="walletFilter"
			[totalCountClient]="totalCountClient"
			[totalCount]="totalCount"
		></app-wallet-table>

		<!-- no data found -->
		<app-no-data-found
			*ngIf="
				(!spWallets?.length && walletFilter.activeTab == 0) ||
				(!clientWalletList?.length && walletFilter.activeTab == 1)
			"
			[text]="'CLIENT.CLIENT_LIST.NO_TRANSACTIONS'"
		></app-no-data-found>
	</div>

	<!-- pagination -->
	<div class="py-5 max-mobile:overflow-auto">
		<app-pagination
			[totalCount]="walletFilter.activeTab == 0 ? totalCount : totalCountClient"
			[pageNumber]="walletFilter.paging.pageNumber"
			[pageCount]="walletFilter.paging.pageSize"
			(currentPage)="pageChanged($event, walletFilter.paging.pageSize)"
			(itemsCountPerPage)="pageChanged(1, $event)"
		></app-pagination>
	</div>
</div>
<ng-container>
	<mat-sidenav-container [hasBackdrop]="true" class="z-20">
		<mat-sidenav
			position="end"
			#sidenav
			mode="side"
			opened
			class="w-[428px] max-mobile:w-full bg-white text-dark-grey p-12px min-h-screen"
			[fixedInViewport]="true"
			[fixedTopGap]="0"
			[disableClose]="false"
			[fixedBottomGap]="0"
			[disableClose]="false"
			[opened]="false"
		>
			<header class="tw-p-4 p-12px">
				<div class="rtl:text-left ltr:text-right">
					<button (click)="sidenav.toggle()">
						<img src="./assets/images/close-square.svg" alt="" />
					</button>
				</div>
			</header>
			<app-wallet-filter
				#filter
				[filterData]="walletFilter"
				(emitFilter)="getSpWalletList(true, $event); sidenav.toggle()"
				(emitfilterCount)="filterCount = $event"
			></app-wallet-filter>
		</mat-sidenav>
	</mat-sidenav-container>
</ng-container>
